export const CANT_FIND_BUSINESS_TITLE = "Can't find your business?";
export const CANT_FIND_ADDRESS_TITLE = "Can't find your address?";

export const BUSINESS_SEARCH_LABEL = 'Business Name';
export const BUSINESS_SEARCH_PLACEHOLDER = 'Enter Business Name';

export const ESTABLISHMENT_TYPES = 'establishment';
export const ADDRESS_TYPES = 'address';
